<template>
    <div class="floating-save">
        <button class="button save-btn"
                :class="{ 'is-loading': isSaving, 'enabled': isDirty }"
                @click="$emit('save')">
            Save
        </button>
    </div>
</template>

<script>
    export default {
        name: 'SaveButton',
        props: {
            isSaving: { type: Boolean, default: false },
            isDirty: { type: Boolean, default: false },
        },
    };
</script>

<style>
    .floating-save {
        position: fixed;
        bottom: 24px;
        right: calc(16em + 24px);
        z-index: 50;
        border-radius: 4px;
    }

    button.save-btn {
        opacity: 0.85;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
        background-color: #557;
        border-color: #203a59;
        pointer-events: none;
        transition: opacity 0.2s ease, box-shadow 0.25s ease;
    }

    button.save-btn.enabled {
        background-color: #203a59;
        border-color: transparent;
        pointer-events: unset;
        color: #f5f5f5;
    }

    button.save-btn.enabled:hover {
        opacity: 1;
        box-shadow: 0 4px 5px rgba(66, 153, 225, 0.33), 0 2px 8px rgba(0, 0, 0, 0.4);
    }
</style>
